import { useLocale } from 'odc-shared/i18n';
import React, { useState } from 'react';

import website from '@src/constants/website';

import Partners from './Partners';

import './index.scss';

interface CopyRightProps {
  isMediation?: boolean;
  className?: string;
  /**
   * 链接文案是否跟随 i18n 翻译。
   *
   * 官网首页不启用 i18n，保持英文原文（默认 false）；仅已支持多语言的页面（帮助中心）传 true。
   * 版权行本身是法务确认的法律文本，两种情况下都保留英文原文。
   */
  localized?: boolean;
  /**
   * 首页用 Partners 标志行替换左侧版权文字。
   * About / Help Center 保持原版权文案。
   */
  showPartners?: boolean;
}

const CopyRight: React.FC<CopyRightProps> = ({
  isMediation = false,
  localized = false,
  showPartners = false,
}) => {
  const [year] = useState<number>(new Date().getFullYear());
  const { t } = useLocale();

  // 未启用翻译的页面（官网首页）直接展示英文原文（即 key 本身）
  const text = (key: string): string => (localized ? t(key) : key);

  const onCookieSettingsClick = (): void => {
    const btn = document.getElementById('ot-sdk-btn');
    if (!btn) return;
    btn.click();
  };

  const privacyPolicy = isMediation ? website.mediationPrivacyPolicy : website.privacyPolicy;
  const cookiePolicy = isMediation ? website.mediationCookiePolicy : website.cookiePolicy;

  return (
    <div className="odc-copyright">
      {showPartners ? (
        <Partners />
      ) : (
        <p className="copyright-item">© 2025-{year} by Serafino Pte. Ltd. All Rights Reserved.</p>
      )}
      <div className="copyright-option">
        <div className="copyright-item clickable">
          <a target="_blank"
            rel="noreferrer"
            href={privacyPolicy}
          >
            {text('Privacy Policy')}
          </a>
        </div>
        {
          !isMediation && (
            <div className="copyright-item clickable">
              <a
                target="_blank"
                rel="noreferrer"
                href={website.yourPrivacyChoices}
              >
                {text('Your Privacy Choices')}
              </a>
            </div>
          )
        }
        <div className="copyright-item clickable">
          <a
            target="_blank"
            rel="noreferrer"
            href={cookiePolicy}
          >
            {text('Cookie Policy')}
          </a>
        </div>
        <div className="copyright-item clickable" onClick={onCookieSettingsClick}>
          {text('cookie settings')}
        </div>
      </div>
    </div>
  );
};

export default CopyRight;